import React from 'react';
import './ClipObj.css'

const ClipObj=()=>{
    return(
        <>
        <div id='clipcontainer'>
        <div className='clipThis'></div>
        </div>
        </>
    )
}
export default ClipObj;